import Vue from 'vue';
import Component from 'vue-class-component';
import Config from '../config';

@Component({
  template: require('./environment-bar.html')
})
export class EnvironmentBar extends Vue {
  config: any;
  
  created() {
    this.config = Config;
  }
}



// WEBPACK FOOTER //
// src/views/environment-bar.ts